import React from "react";

const Interests = () => {
  return (
    <>
      {/* <!-- Interests--> */}
      <section className="resume-section" id="interests">
        <div className="resume-section-content">
          <h2 className="mb-5">Interests</h2>
          <p>
            My outside interests are:<br />
            * Feel nature.<br />
            * Spending my quality time with my family and friends.<br />
            * Communication with new people's.<br />
            * Making research development in my field.
          </p>
          <p className="mb-0">
            When forced indoors, I follow a number of sci-fi and fantasy genre
            movies and television shows, I am an aspiring chef, and I spend a
            large amount of my free time exploring the latest technology
            advancements in the front-end web development world.
          </p>
        </div>
      </section>
      <hr className="m-0" />
    </>
  );
};

export default Interests;
